import { useEffect, useState } from 'react';
import HelpContactCard from '../../ui/components/HelpContactCard';
import LandingHeader from '../home/homeLandingPage/LandingHeader';
import GetStarted from '../howItWorks/GetStarted';
import AboutBanner from './AboutBanner';
import AboutUsText from './AboutUsText';
import KeyMetrics from './KeyMetrics';

const helpContactData = {
  text: 'View openings',
  link: 'https://jobs.cvviz.com/SmallSmall_',
};

function AboutUs() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <>
      <LandingHeader
        isDropdownOpen={isDropdownOpen}
        setIsDropdownOpen={setIsDropdownOpen}
      />
      <AboutBanner />
      <AboutUsText />
      {/* <KeyMetrics /> */}
      <HelpContactCard
        title="Want to join us"
        linkContent={helpContactData}
        content="Are you passionate about making a real impact on people's lives and redefining financial access in Africa? We're looking for innovative thinkers and driven problem-solvers to join our fast-growing, mission-driven team."
      />
      <GetStarted>
        <h3 className="md:block hidden text-lg font-semibold">Get Started</h3>
        <h3 className="md:hidden text-lg font-bold">Get the app</h3>
      </GetStarted>
    </>
  );
}

export default AboutUs;
